<div class="page-container">
	<div class="floating-tab-container">
		<div class="header-section">
			<h1 class="page-title">
				{{cebe?.codigo | translate}} - {{cebe?.descripcion | translate}}
			</h1>
			<div class="header-actions">
				<button
					mat-icon-button
					(click)="backTab()"
					*ngIf="this.tabGroup?.selectedIndex>0"
					class="nav-btn"
					matTooltip="{{ 'common.previous' | translate }}"
				>
					<mat-icon>arrow_back_ios</mat-icon>
				</button>
				<button
					mat-icon-button
					(click)="forwardTab()"
					*ngIf="this.tabGroup?.selectedIndex != (this.tabGroup?._tabs.length - 1)"
					class="nav-btn"
					matTooltip="{{ 'common.next' | translate }}"
				>
					<mat-icon>arrow_forward_ios</mat-icon>
				</button>
				<button
					mat-stroked-button
					(click)="save()"
					*ngIf="this.tabGroup?.selectedIndex != (this.tabGroup?._tabs.length - 1) && this.cebe?.edicionCebe"
					class="save-btn"
				>
					<mat-icon>save</mat-icon>
					{{ 'common.save' | translate }}
				</button>
			</div>
		</div>
		<mat-tab-group #tabGroup class="floating-tab-group">
			<mat-tab>
				<ng-template mat-tab-label>
					<mat-icon
						*ngIf="!validatedCebeDetailsForm"
						class="example-tab-icon"
						color="warn"
					>
						error_outline
					</mat-icon>
					<mat-icon
						*ngIf="validatedCebeDetailsForm"
						class="example-tab-icon"
						style="color: green"
					>
						check_circle_outline
					</mat-icon>
					{{ 'cebe.generalData.title' | translate}}
				</ng-template>
				<div class="container-fluid">
					<div class="row">
						<div class="col-xl-12 cebe-card">
							<mat-card
								class="mat-elevation-z3 p-0 compact-card h-100"
							>
								<mat-card-content>
									<app-cebe-details-card
										*ngIf="cebe"
										class="h-100"
										[cebe]="cebe"
										[parent]="this"
										(ofertaToggleEvent)="changeOfertaValue($event)"
										(contratoToggleEvent)="changeContratoValue($event)"
										(centroToggleEvent)="changeCentroValue($event)"
										(detailFormComplete)="cebeDetailsFormStatus($event)"
										#cebeDetailsCardComponentRef
									>
									</app-cebe-details-card>
								</mat-card-content>
							</mat-card>
						</div>
					</div>
				</div>
			</mat-tab>
			<mat-tab *ngIf="cebe?.oferta">
				<ng-template mat-tab-label>
					<mat-icon
						*ngIf="!validatedPalForm"
						class="example-tab-icon"
						color="warn"
					>
						error_outline
					</mat-icon>
					<mat-icon
						*ngIf="validatedPalForm"
						class="example-tab-icon"
						style="color: green"
					>
						check_circle_outline
					</mat-icon>
					{{ 'cebe.generalData.palData.title' | translate}}
				</ng-template>
				<div class="container-fluid">
					<div class="row">
						<div class="col-xl-12 cebe-card">
							<mat-card
								class="mat-elevation-z3 p-0 compact-card h-100"
							>
								<mat-card-content>
									<app-cebe-pal-card
										*ngIf="cebe"
										class="h-100"
										[pal]="pal"
										[cebe]="cebe"
										(palFormComplete)="palFormStatus($event)"
										#cebePalCardComponentRef
									>
									</app-cebe-pal-card>
								</mat-card-content>
							</mat-card>
						</div>
					</div>
				</div>
			</mat-tab>
			<mat-tab *ngIf="cebe?.isContrato">
				<ng-template mat-tab-label>
					<mat-icon
						*ngIf="!validatedContractForm"
						class="example-tab-icon"
						color="warn"
					>
						error_outline
					</mat-icon>
					<mat-icon
						*ngIf="validatedContractForm"
						class="example-tab-icon"
						style="color: green"
					>
						check_circle_outline
					</mat-icon>
					{{ 'cebe.generalData.contractData.title' | translate}}
				</ng-template>
				<div class="container-fluid">
					<div class="row">
						<div class="col-xl-12 cebe-card">
							<mat-card
								class="mat-elevation-z3 p-0 compact-card h-100"
							>
								<mat-card-content>
									<app-contract-details-card
										*ngIf="contract"
										class="h-100"
										[contract]="contract"
										[cebe]="cebe"
										(contractFormComplete)="contractFormStatus($event)"
										#contractDetailsCardComponentRef
									>
									</app-contract-details-card>
								</mat-card-content>
							</mat-card>
						</div>
					</div>
				</div>
			</mat-tab>
			<mat-tab *ngIf="cebe?.centro">
				<ng-template mat-tab-label>
					{{ 'cebe.generalData.associatedSites' | translate}}
				</ng-template>
				<div class="container-fluid">
					<div class="row">
						<div class="col-xl-12 cebe-card">
							<mat-card
								class="mat-elevation-z3 p-0 compact-card h-100"
							>
								<mat-card-content>
									<app-lista-centros-card
										class="h-100"
										[centros]="centros"
										[cebe]="cebe"
									>
									</app-lista-centros-card>
								</mat-card-content>
								<br />
								<div>
									<app-mini-map
										[cebeId]="contextLocation.cebe"
										[cebe]="cebe"
									></app-mini-map>
								</div>
							</mat-card>
						</div>
					</div>
				</div>
			</mat-tab>
		</mat-tab-group>
	</div>
</div>
